'use client';

import { type FC } from 'react';

import { useAbTest } from '@packages/shared/src/abtesting/useAbTest/useAbTest';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

const IndividualEnrollment = ({ testId }: { testId: string }) => {
  /** only used for side-effects, to enroll the user in the test and enable other parts of the app to use the test, and send outcomes */
  useAbTest(testId);

  return null;
};

export const AbTestEnrollments: FC = () => {
  const {
    abTesting: {
      clientSideEnrollment: { activeTestIds },
    },
  } = useConfig();

  return (
    <>
      {activeTestIds.map((testId) => (
        <IndividualEnrollment key={testId} testId={testId} />
      ))}
    </>
  );
};
